import { Input } from "@chakra-ui/react";
import { useController, useWatch } from "react-hook-form";
import { useIntl } from "react-intl";
import { useSearch } from "../../../contexts/Search";
import useCombinedRefs from "../../../hooks/useCombinedRefs";
import useDebounce from "../../../hooks/useDebounce";

/**
 * @typedef {Object} Props
 * @property {import("react").MutableRefObject<any>} inputRef
 * @property {import("react").MutableRefObject<any[]>} optionsRef
 * @property {() => void} toggleFirstOption
 *
 * @param {Props} props
 */
function SearchInput(props) {
  const { inputRef: _inputRef, optionsRef, toggleFirstOption } = props;

  const intl = useIntl();

  const { onSubmit } = useSearch();

  const {
    response: { isValidating },
    form: { getValues, setValue },
    submittedFields,
  } = useSearch();

  const { field } = useController({ name: "term" });

  const inputRef = useCombinedRefs(field.ref, _inputRef);

  const term = useWatch({ name: "term" });

  const debouncedTerm = useDebounce(term, { delay: 250 });

  if (debouncedTerm === term && debouncedTerm !== submittedFields.term) {
    setValue("page", "1");
    onSubmit();
  }

  return (
    <Input
      {...field}
      ref={inputRef}
      size="sm"
      type="search"
      placeholder={intl.formatMessage({
        defaultMessage: "Rechercher...",
      })}
      autoComplete="off"
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          if (term === submittedFields.term && !isValidating) {
            // on attend que les résulstats soit affichés avant de valider
            event.preventDefault();
            toggleFirstOption();
          }
        }
        if (event.key === "Escape") {
          if (getValues("term") !== "") {
            setValue("term", "", { shouldValidate: true });
            event.preventDefault();
            event.stopPropagation();
          }
        }
        if (event.key === "ArrowDown") {
          event.preventDefault();
          optionsRef?.current?.[0]?.focus?.();
        }
      }}
      variant="outline"
      flexGrow={1}
    />
  );
}

export default SearchInput;
